<app-header></app-header>

<mat-sidenav-container>
    <mat-sidenav mode="side" [opened]="isOpen">
        <ul>
            <li><a routerLink="/documents">Documents</a></li>
            <li><a routerLink="/authors">Authors</a></li>
        </ul>
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet />
    </mat-sidenav-content>
</mat-sidenav-container>
